import { RequestRoot, uCRC } from "types";
import { IPrintDepartment } from "../model/print-department";
import { AppContext, PrintForm } from "controls";
import { PrintQRCodeGenerationService } from "../service/print-qrcode-generation.service";

export class PrintFromV1 extends PrintForm {
    model: RequestRoot;
    department: IPrintDepartment;
    version: string;

    constructor(
        protected appContext: AppContext,
        protected qrCodeService: PrintQRCodeGenerationService) {
        super(appContext);
    }

    calculateModelCrc32(): string {
        return uCRC(JSON.stringify(this.model)).toString(36).toUpperCase();
    }

    get jobIndexes(): number[] {
        const res: number[] = [2];
        let pos = 10;
        while (true) {
            const next = this.model.features.applicant.jobRecords.slice(pos, pos + 8);
            if (next.length) {
                res.push(pos);
                pos += 8;
            } else {
                return res;
            }
        }
    }

    get appNameChanges(): string {
        let res = '';
        let pos = 0;
        while (true) {
            const next = this.join(`applicant.nameChanges.${pos}.lastName`, `applicant.nameChanges.${pos}.firstName`, `applicant.nameChanges.${pos}.middleName`, `applicant.nameChanges.${pos}.year`, `applicant.nameChanges.${pos}.location`);
            ++pos;
            if (next) {
                res && (res += '; ');
                res += next;
            } else {
                return res;
            }
        }
    }

    get repNameChanges(): string {
        let res = '';
        let pos = 0;
        while (true) {
            const next = this.join(`representative.nameChanges.${pos}.lastName`, `representative.nameChanges.${pos}.firstName`, `representative.nameChanges.${pos}.middleName`, `representative.nameChanges.${pos}.year`, `representative.nameChanges.${pos}.location`);
            ++pos;
            if (next) {
                res && (res += '; ');
                res += next;
            } else {
                return res;
            }
        }
    }

    private qrImg: string | null = null;
    private qrImgInet: string | null = null;
    private qrErr: boolean | null = null;
    private qrInit() {
        if (this.qrErr === null && this.model && this.department) {
            const qrImg = this.qrCodeService.getEmbedQrCode(this.model, this.department);
            const qrImgInet = this.qrCodeService.getInetQrCode(this.model);
            if (typeof qrImg === 'string' && typeof qrImgInet === 'string') {
                this.qrImg = qrImg;
                this.qrImgInet = qrImgInet;
                this.qrErr = false;
            } else {
                this.qrImg = '';
                this.qrImgInet = '';
                this.qrErr = true;
            }
        }
    }

    get qrSucc() {
        this.qrInit();
        return this.qrErr === false;
    }

    get qrFail() {
        this.qrInit();
        return this.qrErr === true;
    }

    get qrCodeImage() {
        return this.qrImg;
    }

    get qrCodeImageInet() {
        return this.qrImgInet;
    }

    get qrCodeImageNormalW() {
        return this.qrCodeService.getEmbedImageWidthNormal();
    }

    get qrCodeImageNormalH() {
        return this.qrCodeService.getEmbedImageHeightNormal();
    }

    get qrCodeImageLargeW() {
        return this.qrCodeService.getEmbedImageWidthLarge();
    }

    get qrCodeImageLargeH() {
        return this.qrCodeService.getEmbedImageHeightLarge();
    }

    get qrCodeImageHugeW() {
        return this.qrCodeService.getEmbedImageWidthHuge();
    }

    get qrCodeImageHugeH() {
        return this.qrCodeService.getEmbedImageHeightHuge();
    }

    get inetQrCodeImageW() {
        return this.qrCodeService.getInetImageWidth();
    }

    get inetQrCodeImageH() {
        return this.qrCodeService.getInetImageHeight();
    }
}
